import React from 'react';
import { setStoreData } from '../../store/auth';
import { API } from 'aws-amplify';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

function LicencePlans({ plan }) {
  console.log('plan: ', plan);
  let domainCount = plan?.domains?.filter(e => e != '').length ?? 0;
  return (
    <div className='border border-gray-200 mb-2 p-3 rounded-md max-w-md'>
      <p className=''>
        {domainCount} / {plan.license_number} : <span className={(plan.subscription_status.toLowerCase() == 'canceled' || plan.subscription_status.toLowerCase() == 'cancelled') ? 'line-through' : ''}>{plan.license_key}</span>{' '}
        {(plan.subscription_status.toLowerCase() == 'canceled' || plan.subscription_status.toLowerCase() == 'cancelled')
          ? '(Canceled)'
          : ''}
      </p>
      <ul className='max-w-md divide-y divide-gray-200'>

        {domainCount ? plan.domains.filter(e => e != '').map((domain) => {
          return <LicencePlan domain={domain} key={domain} />;
        }) : <LicencePlan domain={'No available domains.'} />}
      </ul>
    </div>
  );
}

function LicencePlan({ domain }) {
  return (
    <li className='pb-2 pt-2' key={domain}>
      <div className='flex items-center space-x-4'>
        <div className='flex-shrink-0'>
          <img
            className='w-8 h-8 rounded-full'
            src='/apple-touch-icon.png'
            alt='Neil image'
          />
        </div>
        <div className='flex-1 min-w-0'>
          <p className='text-sm font-medium text-gray-900 truncate'>{''}</p>
        </div>
        <div className='inline-flex items-center text-base font-semibold text-gray-900'>
          {domain}
        </div>
      </div>
    </li>
  );
}

export default function Sites() {
  const navigate = useNavigate();
  const { isAuthenticated, user, plan, tmpUser } = useSelector(
    (state) => state.auth.data || {}
  );
  const dispatch = useDispatch();
  const [plans, setPlans] = useState({
    subscriptions: [],
    invoices: [],
    billings: {},
  });
  const [loading, setLoading] = useState(true);
  const getPlanFromProps = function () {

    if (plan === null) {
      fetchPlans();

    } else {
      setPlans(plan);
      setLoading(false);
    }
  };
  const fetchPlans = async () => {
    if (!user) return;
    const session = user.getSignInUserSession();

    const myInit2 = {
      queryStringParameters: {
        action: 'plan',
      },
      headers: {
        Authorization: `Bearer ${session.getIdToken().getJwtToken()}`,
      },
    };
    await API.get('HandLAPI', '/myaccount', myInit2)
      .then((response) => {
        console.log(response);
        setPlans(response);

        if (response.subscriptions.length > 0) {
          dispatch(
            setStoreData({ data: { plan: response, AppEligible: false } })
          );
        }
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }
  useEffect(() => {
    console.log(isAuthenticated);
    if (isAuthenticated && user) {
      getPlanFromProps();
    } else if (!isAuthenticated) {
      navigate('/');
    }
  }, []);
  if (loading) {
    return (
      <div className='flex justify-center'>
        <div className='fa-3x'>
          <i className='fa fa-spinner fa-spin'></i>
        </div>
      </div>
    );
  }

  if (!plans.subscriptions || plans.subscriptions.length == 0) {
    return <div>No sites to display.</div>;
  }

  return plans.subscriptions.map((plan) => (
    <LicencePlans plan={plan} key={plan.license_key} />
  ));
}
